import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../../../assets/svg/ZookeeperLogo.svg";
import logoWhite from "../../../assets/svg/ZookeeperLogoWhite.svg";
import { ThemeContext } from "../../../contexts/ThemeContext";
import ToggleDrawer from "../../../contexts/ToggleDrawer";
import { nonOverflowingTitleSx } from "../../../enums/Styles";
import * as UrlPath from "../../../enums/UrlPaths";
import useNavigationTitles from "../../../hooks/useNavigationTitles";
import useUser from "../../../hooks/useUser";
import UserAvatar from "../../avatar/UserAvatar";
import BookingModal from "../../modals/bookingModalComponents/components/BookingModal";
import BookingModalContext from "../../modals/bookingModalComponents/context/BookingModalContext";
import CustomDialog from "../../wrappers/CustomDrawer";
import LinkTo from "../../wrappers/LinkTo";
import NoClinicWrapper from "../../wrappers/NoClinicWrapper";
import { useIsHomePage } from "../hooks/useIsHomePage";

export default function Header() {
  const title = useNavigationTitles();
  const { t } = useTranslation();
  const { mode } = React.useContext(ThemeContext);
  const headerLogo = mode == "dark" ? logo : logoWhite;
  const { roles, currentClinic } = useUser();

  const isInHomePage = useIsHomePage();

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%" }}
    >
      {isInHomePage ? null : (
        <>
          {/* Title */}
          <Grid item xs={6} sm={5} md={3} height={"100%"}>
            <Typography
              lang="de" // This tells the browser to use German syllable rules for correct "-" hyphenation breaks
              color={"white"}
              sx={nonOverflowingTitleSx}
            >
              {title}
            </Typography>
          </Grid>

          {/* Logo */}
          {!isInHomePage && (
            <Grid
              item
              xs={12}
              md={3}
              display={{ xs: "none", md: "flex" }}
              justifyContent="center"
              height={"100%"}
            >
              <LinkTo to={UrlPath.HOME}>
                {/* TODO:  Change this to white */}
                <img src={headerLogo} width="200px" alt="Logo" />
              </LinkTo>
            </Grid>
          )}
        </>
      )}

      <Grid
        item
        xs={isInHomePage ? 12 : 6}
        sm={isInHomePage ? 12 : 4}
        md={isInHomePage ? 12 : 3}
        height={"100%"}
      >
        <Grid container spacing={2} justifyContent="flex-end">
          {!roles.master && !isInHomePage && currentClinic.id && (
            <Grid item alignItems={"center"} display={"flex"}>
              <NoClinicWrapper show={currentClinic.id}>
                <ToggleDrawer>
                  <CustomDialog
                    buttonSize={"small"}
                    buttonVariant="outlined"
                    buttonMessage={t("BookAppointment")}
                    mobileIcon={<AddOutlinedIcon />}
                    maxWidth={"lg"}
                    testId={"appointment.booking-form.header"}
                  >
                    <BookingModalContext key={"header-booking-context"}>
                      <BookingModal key={"header-booking-modal"} />
                    </BookingModalContext>
                  </CustomDialog>
                </ToggleDrawer>
              </NoClinicWrapper>
            </Grid>
          )}

          <Grid item>
            <UserAvatar />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
